import { render, staticRenderFns } from "./SeriesImgComTile.vue?vue&type=template&id=b5f15890&scoped=true&"
import script from "./SeriesImgComTile.vue?vue&type=script&lang=js&"
export * from "./SeriesImgComTile.vue?vue&type=script&lang=js&"
import style0 from "./SeriesImgComTile.vue?vue&type=style&index=0&id=b5f15890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f15890",
  null
  
)

component.options.__file = "SeriesImgComTile.vue"
export default component.exports